"use strict";
//@ts-nocheck
/**
 * pageopt
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var pageopt = {
    urlkeyvalues: {
        pagenumber: "pageNumber",
        pagesize: "pageSize",
        sortname: "sortColumns",
        sortorder: "sortTypes"
    },
    resetSlt: function (_cont) {
        if (!_cont)
            _cont = $(".cateday_cont2");
        _cont.find('.filter_more ul').on('click', 'li', function (event) {
            // 阻止弹窗中字母的点击
            if (!$(this).attr('data-value'))
                return;
            var tli = $(this).detach();
            var last = $('.filter_ul li:last', _cont).detach();
            $(".filter_ul", _cont).append(tli);
            $('.' + last.data("szm"), _cont).length ? $('.' + last.data("szm"), _cont).after(last) : $(".hover_ul", _cont).append(last);
            ;
            tli.addClass('at2').siblings().removeClass('at2');
            !_cont.find(".hover_ul li[data-szm='" + tli.data("szm") + "']").length && _cont.find(".hover_ul ." + tli.data("szm")).hide();
            _cont.find(".hover_ul ." + last.data("szm")).show();
            _cont.find('.hover_ul').hide();
        });
        $(".filter_more ul").hover(function () {
            jQuery(this).addClass('hover').show();
        }, function () {
            jQuery(this).removeClass('hover').hide();
        });
        $(".filter_more").on('mouseenter', function (event) {
            var o = jQuery(this);
            setTimeout(function () {
                o.find('ul').show();
            }, 100);
        }).on('mouseleave', function (event) {
            var o = jQuery(this);
            setTimeout(function () {
                if (!o.find('ul').hasClass('hover')) {
                    o.find('ul').hide();
                }
            }, 100);
        });
    },
    //datekey:报告期，sortname报表默认排序字段，type：报表type参数
    gpzydataobj: {
        scgk: { type: "RPT_CSDC_STATISTICS", showcount: 5, st: "TRADE_DATE", sr: "-1", filter: "" },
        zybl: { type: "RPT_CSDC_LIST_NEWEST", showcount: 5, st: "PLEDGE_RATIO", sr: "-1", filter: "" },
        zygd: { type: "RPTA_APP_ACCUMDETAILS", showcount: 8, st: "NOTICE_DATE", sr: "-1", filter: "" },
        fbtj: { type: "RPT_GDZY_ZYJG_SUM", showcount: 10, st: "ORG_NUM", sr: "-1", filter: "(PFORG_TYPE=\"\u8BC1\u5238\")" },
        hysj: { type: "RPT_CSDC_INDUSTRY_STATISTICS", showcount: 5, st: "AVERAGE_PLEDGE_RATIO", sr: "-1", filter: "" }
    },
    columns: {
        scgk: {
            TRADE_DATE: emfield.date,
            PM_RATIO: {
                formatter: { zoom: -2 }
            },
            PLEDGE_CO_NUM: {
                formatter: { num: 0 }
            },
            DAILY_STATISTICS: {
                formatter: { num: 2, trim: true }
            },
            TOTAL_PLEDGED_SHARES: {
                formatter: { num: 2, zoom: 4 }
            },
            PLEDGE_MARKET_VALUE: {
                formatter: { num: 2, zoom: 4 }
            },
            CSI_300_INDEX: {
                formatter: { num: 2 }
            },
            CSI_300_CHG: {
                formatter: { showcolor: true, num: 2, fix: '%' }
            }
        },
        zybl: {
            SECURITY_CODE: emfield.code,
            SECURITY_NAME_ABBR: emfield.name,
            stockxg: {
                formatter: function (value, item, i, field) {
                    var c = item.SECURITY_CODE;
                    return "<a class=\"red\" href=\"/gpzy/detail/" + c + ".html\">\u8BE6\u7EC6</a>&nbsp;&nbsp;<a href=\"/stockdata/" + c + ".html\">\u6570\u636E</a>";
                }
            },
            TRADE_DATE: { formatter: { datefmt: "YYYY-MM-DD" } },
            REPURCHASE_BALANCE: {
                formatter: { zoom: 4, trim: true }
            },
            PLEDGE_MARKET_CAP: {
                formatter: { zoom: 4 }
            },
            PLEDGE_DEAL_NUM: {
                formatter: { num: 0, omit: false }
            },
            REPURCHASE_UNLIMITED_BALANCE: {
                formatter: { zoom: 4, trim: true }
            },
            REPURCHASE_LIMITED_BALANCE: {
                formatter: { zoom: 4, trim: true }
            },
            Y1_CLOSE_ADJCHRATE: {
                formatter: { showcolor: true, num: 2 }
            },
            INDUSTRY: {
                formatter: function (value, item, i, field) {
                    return value ? "<a style=\"cursor: pointer;\">" + value + "</a>" : "-"; //所属行业
                },
                events: {
                    'click a': function (e, value, row, index) {
                        $(".cateday_cont2 li").each(function () {
                            if ($(this).data("value") == value) {
                                $(this).click();
                                return false;
                            }
                        });
                    }
                }
            },
            hy: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].strformat(item.INDUSTRY); //所属行业
                }
            }
        },
        zygd: {
            SECURITY_CODE: emfield.code,
            SECURITY_NAME_ABBR: emfield.name,
            stockxg: {
                formatter: function (value, item, i, field) {
                    var c = item.SECURITY_CODE;
                    return "<a class=\"red\" href=\"/gpzy/detail/" + c + ".html\">\u8BE6\u7EC6</a>&nbsp;&nbsp;<a href=\"/stockdata/" + c + ".html\">\u6570\u636E</a>";
                }
            },
            HOLDER_NAME: emfield.string,
            PF_ORG: emfield.string,
            PF_START_DATE: emfield.date,
            NOTICE_DATE: emfield.date,
            zyjg: {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].isEmpty(item.PF_SECURITY_CODE) || /^[A-Z]\d{5}/.test(item.PF_SECURITY_CODE))
                        return fieldtools_1["default"].strformat(item.PF_ORG);
                    return "<a href=\"/gpzy/detail/" + item.SECURITY_CODE + "-" + item.PF_SECURITY_CODE + ".html#zyjg_md\">" + item.PF_ORG + "</a>";
                }
            },
            zyzt: {
                formatter: function (value, item, i, field) {
                    if (fieldtools_1["default"].strformat(item.UNFREEZE_STATE) == "未解押") {
                        return fieldtools_1["default"].strformat(item.WARNING_STATE) + "(\u4F30\u7B97)";
                    }
                    return fieldtools_1["default"].strformat(item.UNFREEZE_STATE);
                }
            },
            jgzyxg: {
                formatter: function (value, item, i, field) {
                    var c = item.SECURITY_CODE;
                    return "<a class=\"red\" href=\"/gpzy/detail/" + c + "-" + item.PF_SECURITY_CODE + ".html#zyjg_md\">详细</a>&nbsp;&nbsp;<a href=\"/stockdata/" + c + ".html\">个股数据</a>";
                }
            },
            PLEDGE_DEAL_NUM: {
                formatter: { num: 0 }
            },
            SUM_PF_NUM: {
                formatter: { zoom: 4 }
            },
            MARKET_CAP: {
                formatter: { num: 2 }
            },
            MARKET_CAP_jg: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(item.MARKET_CAP, { zoom: 4 });
                }
            },
            WARNING_STATE_1_RATE: { formatter: { num: 5521, omit: false, zoom: 2 } },
            WARNING_STATE_2_RATE: { formatter: { num: 5521, omit: false, zoom: 2 } },
            WARNING_STATE_3_RATE: { formatter: { num: 5521, omit: false, zoom: 2 } }
        },
        fbtj: {
            SECURITY_NAME_ABBR: emfield.string,
            xg: {
                formatter: function (value, item, i, field) {
                    var c = item.SECURITY_CODE;
                    return "<a class=\"red\" href=\"/gpzy/detail/" + c + ".html?type=jgzy#zyjg_md\">\u8BE6\u7EC6</a>&nbsp;&nbsp;<a href=\"/stockdata/" + c + ".html\">\u6570\u636E</a>&nbsp;&nbsp;<a href=\"//" + (window.ymcdx2guba || "guba.eastmoney.com") + "/list," + c + ".html\">\u80A1\u5427</a>";
                }
            },
            ORG_NUM: { formatter: { num: 0 } },
            PLEDGE_DEAL_NUM: { formatter: { num: 0 } },
            PLEDGE_NUM: { formatter: { zoom: 4 } },
            WARNING_STATE_1_RATE: { formatter: { num: 5521, omit: false, zoom: 2 } },
            WARNING_STATE_2_RATE: { formatter: { num: 5521, omit: false, zoom: 2 } },
            WARNING_STATE_3_RATE: { formatter: { num: 5521, omit: false, zoom: 2 } }
        },
        hysj: {
            INDUSTRY: emfield.string,
            hyxg: {
                formatter: function (value, item, i, field) {
                    return "<a class=\"red\" href=\"/gpzy/zybl.html?hy=" + item.INDUSTRY + "\">\u8BE6\u7EC6</a>";
                }
            },
            ORG_NUM: { formatter: { num: 0 } },
            PLEDGE_TOTAL_NUM: { formatter: { num: 0 } },
            TOTAL_PLEDGE_SHARES: { formatter: { zoom: 4 } },
            PLEDGE_TOTAL_MARKETCAP: { formatter: { zoom: 4 } }
        }
    }
};
window.pageopt = pageopt;
exports["default"] = pageopt;
